// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"vendors-node_modules_react-three_drei_core_Text_js-node_modules_react-three_drei_core_useGLTF-387196":"ac9bc530","src_EmeraldsCatcher_tsx":"d642db27","node_modules_web-vitals_dist_web-vitals_js":"3b84fc5f","vendors-node_modules_howler_dist_howler_js":"8b50b46f"}[chunkId] + ".chunk.js";
};